import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "antd";

import "../../../Admin/UserManagement/NewEmployee/NewEmployeeStyles.scss";
import { DrawerComponent } from "../../../../components/UI/Drawer/DrawerComponent";
import {
  clearNewStateAdminError,
  createStateAdmin,
  editStateAdmin,
} from "../../../../slices/StateDOTAdmin/userManagement.slice";
import { showSuccess } from "../../../../helpers/Notifications/Notification";
import NewFormActions from "../../../../components/Common/NewFormActions";
import NewFormHeader from "../../../../components/Common/NewFormHeader";
import FormFields from "./FormFields";

const NewStateAdmin = ({
  drawerVisible,
  onClose,
  setDrawerVisible,
  populateStateAdminList,
  isEdit,
  stateAdminData,
  userTitle,
  handleViewOrganization,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { newStateAdminError, createStateAdminLoading } = useSelector(
    (state) => state.stateAdminManagement
  );
  const userTitleLower = userTitle.toLowerCase();

  const setDrawerClose = () => {
    onClose();
    dispatch(clearNewStateAdminError());
  };

  const onSubmitSuccess = (values) => {
    {
      isEdit
        ? dispatch(
            editStateAdmin(
              {
                email: stateAdminData?.email,
              },

              (status) => {
                if (status === "success") {
                  showSuccess(userTitle + " details edited");
                  populateStateAdminList();
                  setDrawerVisible(false);
                }
              }
            )
          )
        : dispatch(
            createStateAdmin(values, (stateAdmin) => {
              if (stateAdmin) {
                showSuccess(`New ${userTitleLower} Added`);
                handleViewOrganization(stateAdmin);
                setDrawerVisible(false);
              }
            })
          );
    }
  };
  return (
    <DrawerComponent
      content={
        <>
          <NewFormHeader
            title={`${isEdit ? "Edit" : "Add"} ${userTitle}`}
            description={`Fill the following fields to add an ${userTitle}.`}
            error={newStateAdminError}
          />
          <Form
            layout="vertical"
            onFinish={onSubmitSuccess}
            autoComplete="off"
            style={{ paddingTop: 20 }}
            validateTrigger="onBlur"
            initialValues={{
              name: stateAdminData?.name,
              email: stateAdminData?.email,
            }}
            form={form}
          >
            {" "}
            <FormFields
              isEdit={isEdit}
              stateAdminData={stateAdminData}
              form={form}
              userTitle={userTitle}
            />
            <NewFormActions
              isEdit={isEdit}
              onHandleClose={setDrawerClose}
              isLoading={createStateAdminLoading}
            />
          </Form>
        </>
      }
      drawerVisible={drawerVisible}
      onClose={setDrawerClose}
    />
  );
};

export default NewStateAdmin;
